module.exports = __webpack_public_path__ + "assets/favicon.26ec0d65.ico";